import React, { useState } from "react";
import moment from "moment";
import DropDown from "./dropdown";

const today = moment();

const OPTIONS = [
  {
    label: "Daily",
    getRange: () => {
      const endDate = moment();
      const startDate = moment(endDate).subtract(1, "days");
      const previousEndDate = moment(startDate).subtract(1, "days");
      const previousStartDate = moment(previousEndDate).subtract(1, "days");
      return {
        startDate: startDate.toDate(),
        endDate: endDate.toDate(),
        previousStartDate: previousStartDate.toDate(),
        previousEndDate: previousEndDate.toDate(),
      };
    },
  },
  {
    label: "Last 7 Days",
    getRange: () => {
      const endDate = moment();
      const startDate = moment(endDate).subtract(6, "days");
      const previousEndDate = moment(startDate).subtract(1, "days");
      const previousStartDate = moment(previousEndDate).subtract(6, "days");
      return {
        startDate: startDate.toDate(),
        endDate: endDate.toDate(),
        previousStartDate: previousStartDate.toDate(),
        previousEndDate: previousEndDate.toDate(),
      };
    },
  },
  {
    label: "This Month",
    getRange: () => {
      const endDate = moment();
      const startDate = moment(endDate).startOf("month");
      const diff = endDate.diff(startDate, "days");
      const previousEndDate = moment(startDate).subtract(1, "days");
      const previousStartDate = moment(previousEndDate).subtract(diff, "days");
      return {
        startDate: startDate.toDate(),
        endDate: endDate.toDate(),
        previousStartDate: previousStartDate.toDate(),
        previousEndDate: previousEndDate.toDate(),
      };
    },
  },
  {
    label: "Last Month",
    getRange: () => {
      const startDate = moment().subtract(1, "months").startOf("month");
      const endDate = moment(startDate).endOf("month");
      const diff = endDate.diff(startDate, "days");
      const previousEndDate = moment(startDate).subtract(1, "days");
      const previousStartDate = moment(previousEndDate).subtract(diff, "days");
      return {
        startDate: startDate.toDate(),
        endDate: endDate.toDate(),
        previousStartDate: previousStartDate.toDate(),
        previousEndDate: previousEndDate.toDate(),
      };
    },
  },
  {
    label: "This Quarter",
    getRange: () => {
      const endDate = moment();
      const startDate = moment(endDate).subtract(3, "months");
      const diff = endDate.diff(startDate, "days");
      const previousEndDate = moment(startDate).subtract(1, "days");
      const previousStartDate = moment(previousEndDate).subtract(diff, "days");
      return {
        startDate: startDate.toDate(),
        endDate: endDate.toDate(),
        previousStartDate: previousStartDate.toDate(),
        previousEndDate: previousEndDate.toDate(),
      };
    },
  },
  {
    label: "This Year",
    getRange: () => {
      const endDate = moment();
      const startDate = moment(endDate).startOf("year");
      const diff = endDate.diff(startDate, "days");
      const previousEndDate = moment(startDate).subtract(1, "days");
      const previousStartDate = moment(previousEndDate).subtract(diff, "days");
      return {
        startDate: startDate.toDate(),
        endDate: endDate.toDate(),
        previousStartDate: previousStartDate.toDate(),
        previousEndDate: previousEndDate.toDate(),
      };
    },
  },
  {
    label: "Last 12 Months",
    getRange: () => {
      const endDate = moment();
      const startDate = moment(endDate).subtract(1, "years");
      const diff = endDate.diff(startDate, "days");
      const previousEndDate = moment(startDate).subtract(1, "days");
      const previousStartDate = moment(previousEndDate).subtract(diff, "days");
      return {
        startDate: startDate.toDate(),
        endDate: endDate.toDate(),
        previousStartDate: previousStartDate.toDate(),
        previousEndDate: previousEndDate.toDate(),
      };
    },
  },
];

const DateRange = ({ dateRange, onChange, selectedLabel, title='', disabledLabels = [], isDisabled = false }) => {
  const filteredOptions = OPTIONS.filter(opt => !disabledLabels.includes(opt.label));
  
  const dropdownOptions = filteredOptions.map((opt, index) => ({
    value: index,
    label: title ? `${title} ${opt.label}` : opt.label,
    originalLabel: opt.label
  }));
  
  const selectedOption = selectedLabel 
    ? dropdownOptions.find(opt => opt.originalLabel === selectedLabel)
    : dropdownOptions[1];
    const handleChange = (selected) => {
    const idx = selected.value;
    const range = filteredOptions[idx].getRange();
    onChange([{ ...range, label: filteredOptions[idx].label }], filteredOptions[idx].label);
  };
  return (    
    <DropDown
      options={dropdownOptions}
      value={selectedOption}
      onChange={handleChange}
      placeholder="Select date range"
      isSearchable={false}
      loading={false}
      isDisabled={isDisabled}
      isClearable={false}
    />
  );
};

export default DateRange;
